import avaitor from '@assets/nav/aviator.gif';
import jetx from '@assets/nav/jetx.svg';
import casino from '@assets/nav/casino.gif';
import games from '@assets/nav/games.gif';
import live from '@assets/nav/live.gif';
import promo from '@assets/nav/promo.gif';
import sport from '@assets/nav/sport.gif';
import keno from '@assets/nav/keno-svg.svg';
import spin from '@assets/nav/spin.png';
import virtualsport from '@assets/nav/virtual-sport.svg';
import raffle from '@assets/nav/trophy.svg';

// hulugaming logos
import hulugaming_promo from '@assets/nav/hulugaming/promo.svg';
import hulugaming_games from '@assets/nav/hulugaming/games.svg';
import hulugaming_avaitor from '@assets/nav/hulugaming/avaitor.svg';
import hulugaming_jetx from '@assets/nav/hulugaming/jetx.svg';
import hulugaming_goldenrace from '@assets/nav/hulugaming/goldenrace.svg';
import hulugaming_keno from '@assets/nav/hulugaming/keno.svg';
import hulugaming_plinko from '@assets/nav/hulugaming/plinko.svg';
import hulugaming_spin from '@assets/nav/hulugaming/spin&wheel.svg';
import hulugaming_raffle from '@assets/nav/hulugaming/raffle.svg';
import hulugaming_bank from '@assets/nav/hulugaming/bank.svg';
import hulugaming_check_ticket from '@assets/nav/hulugaming/checkTicket.svg';
import hulugaming_more from '@assets/nav/hulugaming/more.svg';

import hulugaming_crash from '@assets/game/hulugaming/crash.svg';
import hulugaming_slot from '@assets/game/hulugaming/slot.svg';
import hulugaming_mine from '@assets/game/hulugaming/mine.svg';
import hulugaming_game_plinko from '@assets/game/hulugaming/plinko.svg';
import hulugaming_game_keno from '@assets/game/hulugaming/keno.svg';
import hulugaming_virtual from '@assets/game/hulugaming/virtual.svg';
import hulugaming_roulette from '@assets/game/hulugaming/roulette.svg';
import hulugaming_lobby from '@assets/game/hulugaming/lobby.svg';

import bandLogo from '@assets/logo.png';

// import accumulator from '@assets/nav/accumulator.svg';

export const logo = bandLogo;
export const mobileLogo = bandLogo;

export const marks = {
  0: {
    style: {
      color: 'white',
    },
    label: '3H',
  },
  20: {
    style: {
      color: 'white',
    },
    label: '6H',
  },
  40: {
    style: {
      color: 'white',
    },
    label: '12H',
  },
  60: {
    style: {
      color: 'white',
    },
    label: '1D',
  },
  80: {
    style: {
      color: 'white',
    },
    label: '3D',
  },
  100: {
    style: {
      color: 'white',
    },
    label: 'ALL',
  },
};

export const HOUR_FILTER_LIST = [
  {
    id: 1,
    hour: 1,
  },
  {
    id: 3,
    hour: 3,
  },
  {
    id: 6,
    hour: 6,
  },
  {
    id: 12,
    hour: 12,
  },
];
export const NARROW_TEMPLATE = 1;
export const WIDE_TEMPLATE = 2;
export const MediaSize = 768;
export const MEDIA_SIZE = 1264;
export const MIN_STAKE_ONLINE = 5;
export const MIN_STAKE_OFFLINE = 20;
export const MEDIA_SIZE_XL = 1264;
export const MEDIA_SIZE_LG = 1024;
export const MEDIA_SIZE_MD = 912;
export const MEDIA_SIZE_SM = 768;

export const week_Days = {
  Sunday: 'እሁድ',
  Monday: 'ሰኞ',
  Tuesday: 'ማክሰኞ',
  Wednesday: 'እሮብ',
  Thursday: 'ሃሙስ',
  Friday: 'አርብ',
  Saturday: 'ቅዳሜ',
};

export const fr_week_Days = {
  Sunday: 'Dimanche',
  Monday: 'Lundi',
  Tuesday: 'Mardi',
  Wednesday: 'Mercredi',
  Thursday: 'Jeudi',
  Friday: 'Vendredi',
  Saturday: 'Samedi',
};

export const documnetTypes = [
  { name: 'Passport', code: 1 },
  { name: 'ID', code: 2 },
  { name: 'Driving License', code: 3 },
];

export const Regions = {
  Eswatini: ['Hhohho', 'Manzini', 'Lubombo', 'Shiselweni'],
};
export const Towns = [
  'Mbabane',
  'Manzini',
  'Lobamba',
  'Siteki',
  'Nhlangano',
  "Pigg's Peak",
  'Mhlume',
  'Big Bend',
  'Hluti',
  'Hlatikulu',
  'Mankayane',
  'Lavumisa',
  'Nsoko',
];

export const SourceOfFund = [
  { name: 'salary', code: 1 },
  { name: 'savings', code: 2 },
  { name: 'gifts', code: 3 },
  { name: 'other', code: 4 },
];

export const REGISTRATION_FLOW = {
  NORMAL_FLOW: 1,
  NOPASS_FLOW: 2,
  KYC_HEAVY_FLOW: 3,
};

export const OTP_ENABLED = 1;
export const OTP_DISENABLED = 2;

// Market Groups
export const MAIN_MARKET = 1;
export const TOTAL = 2;
export const COMBINATIONS = 3;
export const HALF_TIME = 4;
export const HANDICAPS = 5;

// arbitrary  values
export const FIRST_FOUR_MARKETS = 5;
export const MIN_PHONE_LENGTH = 8;
export const MAX_PHONE_LENGTH = 13;

export const NAV_ICONS = {
  avaitor: avaitor,
  jetx: jetx,
  casino: casino,
  games: games,
  live: live,
  promo: promo,
  sport: sport,
  keno: keno,
  spin: spin,
  virtualsport: virtualsport,
  raffle: raffle,
};
export const HULU_NAV_ICONS = {
  games: hulugaming_games,
  promo: hulugaming_promo,
  bank: hulugaming_bank,
  avaitor: hulugaming_avaitor,
  jetx: hulugaming_jetx,
  keno: hulugaming_keno,
  plinko: hulugaming_plinko,
  spin: hulugaming_spin,
  check: hulugaming_check_ticket,
  raffle: hulugaming_raffle,
  golden: hulugaming_goldenrace,
  more: hulugaming_more,
};
export const HULU_GAME_ICONS = {
  crash: hulugaming_crash,
  slot: hulugaming_slot,
  mines: hulugaming_mine,
  plinko: hulugaming_game_plinko,
  keno: hulugaming_game_keno,
  virtual: hulugaming_virtual,
  roulette: hulugaming_roulette,
  lobby: hulugaming_lobby,
};

export const FrontPageImagesMap = {
  main_banner: 1,
  side_banner: 2,
  casino_games_banner: 3,
  popup_banner: 4,
};

export const BANNER_LOCATION = {
  HOME: 1,
  RIGHT_SIDEBAR: 2,
  GAMES: 3,
  POPUP: 4,
};
export const POPUP_BANNER = 4;
export const SHOW_BANNER_TO = {
  ALL: 1,
  AUTHENTICATED: 2,
  UNAUTHENTICATED: 3,
};
